const deepClone = (value) => {
  return JSON.parse(JSON.stringify(value))
}

// using Fisher-Yates algorithm to shuffle the array
// copied from https://medium.com/@nitinpatel_20236/how-to-shuffle-correctly-shuffle-an-array-in-javascript-15ea3f84bfb
const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--){
    const j = Math.floor(Math.random() * i)
    const temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }

  return array
}


// copied from https://stackoverflow.com/questions/1714786/query-string-encoding-of-a-javascript-object
// and modernised to use modern js
const serialize = (obj, prefix) => {
  const str = []

  for (let p in obj) {
    if (obj.hasOwnProperty(p)) {
      const k = prefix ? prefix + '[' + p + ']' : p
      const v = obj[p]

      str.push((v !== null && typeof v === 'object') ?
        serialize(v, k) :
        encodeURIComponent(k) + '=' + encodeURIComponent(v))
    }
  }
  return str.join('&')
}

const deserialize = (queryString) => {
  const string = decodeURI(queryString)
  const pairs = string.split('&')

  const result = {}

  pairs.forEach((pair) => {
    let [ key, value ] = pair.split('=')
    let arr = true

    if (!isNaN(Number(value))) value = Number(value)

    if (value === 'true') value = true
    if (value === 'false') value = false

    if (key.includes('[')) {
      key = key
        .replace(']', '')
        .split('[')

      if (isNaN(Number(key[1]))) arr = false

      if (!result[key[0]]) {
        result[key[0]] = arr
          ? []
          : {}
      }

      if (arr) return result[key[0]].push(value)

      return result[key[0]][key[1]] = value
    }
  })

  return result
}

export { deepClone, shuffleArray, serialize, deserialize }
